import { Routes } from '@angular/router';
import { HomeComponent } from '../modules/extranet/home/home.component';
import { RouteData } from '../utils/types/models/app.model';
import { Error404Component } from '../modules/extranet/error404/error404.component';
import { NotLoggedInGuard } from '../shared/guards/auth/not-logged-in.guard';
import { AuthGuard } from '../shared/guards/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    children: [
      { path: 'home', pathMatch: 'full', redirectTo: '/' },

      {
        path: '',
        loadChildren: () =>
          import('../modules/extranet/extranet.module').then(
            (m) => m.ExtranetModule
          ),
      },
      {
        path: 'auth',
        loadChildren: () =>
          import('../modules/authentication/authentication.module').then(
            (m) => m.AuthenticationModule
          ),
        canActivate: [NotLoggedInGuard]
      },
      {
        path: '',
        loadChildren: () =>
          import('../modules/intranet/intranet.module').then(
            (m) => m.IntranetModule
          ),
        canActivate: [AuthGuard]
      },

      { path: '**', component: Error404Component, data: { title: '404 Not Found' } as RouteData },
    ],
  },
];
